import React, {} from 'react';
import MediaLibraryWindow from './MediaLIbraryWindow';

const MediaLibraryPage = () => {
    return <MediaLibraryWindow />
};
export default MediaLibraryPage;